import { API_URL } from "../services.props";
import { AuthSignInProps, AuthSignInResProps } from "./auth.props";

const AuthServices = () => {
  const getExampleService = async () => {
    const res = await fetch("https://jsonplaceholder.typicode.com/users");
    if (!res.ok) {
      throw new Error("Error al obtener los usuarios");
    }
    return res.json();
  };

  const signInService = async ({
    email,
    password,
  }: AuthSignInProps): Promise<AuthSignInResProps> => {
    const res = await fetch(API_URL.AUTH_SIGNIN(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    const response = await res.json();

    let user: AuthSignInResProps["data"] = {
      token: response?.token,
      refreshToken: response?.refresh_token || "",
      user: response?.user || "",
      roles: response?.roles || [],
    };
    const emptyUser: AuthSignInResProps["data"] = {
      token: "",
      refreshToken: "",
      user: "",
      roles: [],
    };
    let isError: boolean = false;

    if (response?.code < 200 || response?.code >= 300) {
      isError = true;
    }

    return {
      error: isError,
      typeError: "emailOrPasswordError",
      messageError: "",
      data: isError ? emptyUser : user,
    };
  };

  return { getExampleService, signInService };
};

export default AuthServices;
